// 登录页底部“在线统计”配置
// peakUsers / peakEnterprises 表示对应指标在一天中的“峰值”大小（即负载 100% 时的人数）。
// 实际展示的人数按各时段负载区间在峰值的不同百分比之间平滑波动（详见 Footer 组件的 LOAD_BLOCKS），
// 因此调整这里的峰值即可整体放大或缩小在线用户 / 在线企业的规模。
export default {
  // 是否展示在线统计（用户数 & 企业数）
  showOnlineStats: false,
  // 当前在线用户峰值（负载 100% 时约为该值，对应核心时段 09:00-18:00）
  peakUsers: 3500,
  // 当前在线企业峰值（负载 100% 时约为该值）
  peakEnterprises: 1000,
};
